import { AdminMessage } from "@components/admin/admin-helpers"
import { ContentBlocks, defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Merch Tile",
  description: "A tile to display merchandise items.",
  category: "embed",
  icon: "cart",
  flags: {
    contentWidth: true,
    marginRule: "large-card",
  },
  tags: ["#subpage"],
}

export default defineBlock("merch/merch-tile", (props) => {
  if (!props.item?.contentBlocks) {
    if (env.admin) {
      return <AdminMessage>Please select a merchandise item to display</AdminMessage>
    }
  }
  return (
    <div>
      <ContentBlocks blocks={props.item?.contentBlocks!} />
    </div>
  )
})
